var map = {
	"./4-_Wattathon.mp3": 56,
	"./458627__tetrisrocker__clock.mp3": 57,
	"./Backrooms.mp3": 58,
	"./Finish.mp3": 59,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 01 Mall Open.mp3": 60,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 02 Sale Of The Seventies.mp3": 61,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 03 Third Floor Spending Spree.mp3": 62,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 04 Food Court Calling.mp3": 63,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 05 Grocery Grabbing.mp3": 64,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 06 The Fountain Of Life.mp3": 65,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 07 Phonebooth Call To Home.mp3": 66,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 08 Restroom Retreat.mp3": 67,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 09 Impulse Purchase (Part 1).mp3": 68,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 10 Cash Or Cheque.mp3": 69,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 11 Checkout 2 Now Open.mp3": 70,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 12 Impulse Purchase (Part 2).mp3": 71,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 13 Parking Lot Lost.mp3": 72,
	"./MallMusicMuzakMallOf1974/Mall Music Muzak - Mall Of 1974 - 14 Mall Closed.mp3": 73,
	"./dead.mp3": 74,
	"./dear_god.mp3": 75,
	"./good_luck_w_your_ears_honestly.mp3": 76,
	"./justifiedRecursion.mp3": 77,
	"./no_gods_no_master.mp3": 78,
	"./turntablist.mp3": 79,
	"./watt_3_but_jr_owns_it.mp3": 80,
	"./youbrokeit.mp3": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;